export {
  AttendeeContainer,
  AttendeeProvider,
  useAttendee,
} from './AttendeeContainer';
export {type Attendee, type AttendeeModel} from './attendee-container-machine';
export {readAccessToken} from './attendee-session-token';

import type {
  GuestAuthSuccessEvent,
  GuestAuthSuccessEventName,
} from '@backstage-components/base';

declare global {
  // Extends `#addEventListener` and `#removeEventListener` type definition to
  // include an overload for the custom events dispatched during guest
  // authentication. These are copied from the module implementations so
  // consumers of the `@backstage-components/attendee-container` package will
  // also have access to them.
  interface HTMLElement {
    addEventListener(
      type: GuestAuthSuccessEventName,
      listener: (this: HTMLElement, ev: GuestAuthSuccessEvent) => void,
      options?: boolean | AddEventListenerOptions
    ): void;
    removeEventListener(
      type: GuestAuthSuccessEventName,
      listener: (this: HTMLElement, ev: GuestAuthSuccessEvent) => void,
      options?: boolean | EventListenerOptions
    ): void;
  }
}
